import React, { Component } from "react";
import { Alert } from "react-bootstrap";
import { LINK_EXPIRY, daysUntilExpiry, isLinkExpired } from "../linkExpiry";

export default class ExpiryNotice extends Component {
  constructor(props) {
    super(props);
    this.state = { days: daysUntilExpiry(), expired: isLinkExpired() };
  }

  componentDidMount() {
    // Re-check every minute so the count ticks over without a reload
    this.timer = setInterval(this.tick, 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  tick = () => {
    this.setState({ days: daysUntilExpiry(), expired: isLinkExpired() });
  };

  render() {
    if (this.state.expired) {
      return (
        <Alert bsStyle="danger" className="ExpiryNotice">
          <strong>This link has expired.</strong> Your images are no longer
          available.
        </Alert>
      );
    }
    const { days } = this.state;
    return (
      <Alert bsStyle="warning" className="ExpiryNotice">
        <strong>
          This link will expire in {days} {days === 1 ? "day" : "days"}
        </strong>{" "}
        (at the end of{" "}
        {LINK_EXPIRY.clone().subtract(1, "ms").format("dddd, Do MMMM YYYY")}).
        If you'd like to keep
        your images, please download them before then.
      </Alert>
    );
  }
}
